module.exports = __webpack_public_path__ + "03_short_gold.d411679c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_short_gold.png
// module id = RNtw
// module chunks = 0